export function isIOSSafari(): boolean {
  const ua = navigator.userAgent;

  // Exclude non-Safari iOS browsers
  if (/CriOS|FxiOS/.test(ua)) return false;

  // Check for iPhone or iPad in UA
  if (/iPhone|iPad/.test(ua)) return true;

  // iPadOS 13+ reports as Mac but has touch points
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;

  return false;
}
